import { useState, useCallback } from 'react';
import { Manager, Reference } from 'react-popper';
import { Box } from '@qga/roo-ui/components';
import { HiddenOnSmallScreen, ShowOnSmallScreen } from 'components/Layout';
import MobileContentWrapper from './components/MobileContentWrapper';
import DesktopContentWrapper from './components/DesktopContentWrapper';

const Popover = ({ renderReference, renderContent, title }) => {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), [setOpen]);
  const close = useCallback(() => setOpen(false), [setOpen]);
  const renderPropProps = { isOpen, open, close };
  const content = isOpen ? renderContent(renderPropProps) : null;

  return (
    <Manager>
      <Reference>{({ ref }) => <Box ref={ref}>{renderReference(renderPropProps)}</Box>}</Reference>
      {isOpen && (
        <>
          <HiddenOnSmallScreen>
            <DesktopContentWrapper onClose={close}>{content}</DesktopContentWrapper>
          </HiddenOnSmallScreen>

          <ShowOnSmallScreen>
            <MobileContentWrapper onClose={close} isOpen={isOpen} title={title}>
              {content}
            </MobileContentWrapper>
          </ShowOnSmallScreen>
        </>
      )}
    </Manager>
  );
};

export default Popover;
